import { WorkType } from './../common/interfaces/work-type';
import { Injectable } from '@angular/core';
import { ElementSVC } from './element-svc';
import { HttpClient } from '@angular/common/http';
import { concatMap, of } from 'rxjs';


@Injectable({
  providedIn: 'root'
})
export class WorkTypeService extends ElementSVC {

  worktypes = null;
  workDetails: Array<string> = [];

  constructor(protected override http: HttpClient) {

    super(http);
    this.apiurl += '/work-types';
    this.workDetails = ['29'];

  }

  initialize(){

    return this.http.get(this.apiurl).pipe(concatMap((_: WorkType[]) => {
      
      this.worktypes = _;
      return of(true);

    }));

  }

  getworkTypes(){
    
    return this.worktypes;

  }

  getWorkDetails(){

    return this.workDetails;

  }

  getPaginate(filter?: string){

    return this.http.get(this.apiurl + '-paginate' + (filter!=undefined ? '?' + filter : ''));

  }

  getWorkTypeIdById(id: number){
    return this.worktypes.find((el) => el.id == id);
  }

  
  getWorkTypeById(id: number){
    return this.worktypes.find((el) => el.id == id).title;
  }

  getEquipementsOfWorkTypes(id: number, filter?){

    return this.http.get(this.apiurl + '/' + id + '/equipements'+ filter);

  }

}
